<form
  [formGroup]="form"
  (ngSubmit)="onFormSubmit()"
  [patchForm]="configBooking"
>
  <section class="card mb-3">
    <div class="card-header card-collapse">
      <h2 class="accordion-header">
        <button
          class="accordion-button"
          type="button"
          [attr.aria-expanded]="isCollapsed ? 'false' : 'true'"
          (click)="isCollapsed = !isCollapsed"
          aria-controls="employeeBookingConfig"
        >
          <span class="fs-3">{{
            'employeeModule.employeeBookingConfig' | translate
          }}</span>

          <i
            class="fa fa-fw"
            [ngClass]="isCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"
            attr.aria-label="{{ 'wcag.toggleSection' | translate }}"
            role="img"
          ></i>
        </button>
      </h2>
    </div>

    <div
      *ngIf="!isCollapsed"
      class="card-body"
      [formGroup]="form"
      id="employeeBookingConfig"
    >
      <div class="row">
        <div class="col-lg-6">
          <!-- Type -->
          <div class="mb-4">
            <fieldset>
              <legend class="form-label">
                {{ 'general.type' | translate }}
              </legend>
              <div class="d-flex align-items-center">
                <div class="form-check">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="typeEditable"
                    formControlName="typeEditable"
                  />
                  <label class="form-check-label" for="typeEditable">
                    {{ 'configurationOptionModule.editable' | translate }}
                  </label>
                </div>
              </div>
            </fieldset>
          </div>

          <!-- Product -->
          <div class="mb-4">
            <fieldset>
              <legend class="form-label">
                {{ 'productModule.product' | translate }}
              </legend>
              <div class="d-flex align-items-center">
                <div class="form-check">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="productEditable"
                    formControlName="productEditable"
                  />
                  <label class="form-check-label" for="productEditable">
                    {{ 'configurationOptionModule.editable' | translate }}
                  </label>
                </div>
              </div>
            </fieldset>
          </div>

          <!-- StartTime -->
          <div class="mb-4">
            <fieldset>
              <legend class="form-label">
                {{ 'general.startTime' | translate }}
              </legend>
              <div class="d-flex align-items-center">
                <div class="form-check">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="startTimeEditable"
                    formControlName="startTimeEditable"
                  />
                  <label class="form-check-label" for="startTimeEditable">
                    {{ 'configurationOptionModule.editable' | translate }}
                  </label>
                </div>
              </div>
            </fieldset>
          </div>

          <!-- EndTime -->
          <div class="mb-4">
            <fieldset>
              <legend class="form-label">
                {{ 'general.endTime' | translate }}
              </legend>
              <div class="d-flex align-items-center">
                <div class="form-check">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="endTimeEditable"
                    formControlName="endTimeEditable"
                  />
                  <label class="form-check-label" for="endTimeEditable">
                    {{ 'configurationOptionModule.editable' | translate }}
                  </label>
                </div>
              </div>
            </fieldset>
          </div>

          <!-- Contract -->
          <div class="mb-4">
            <fieldset>
              <legend class="form-label">
                {{ 'employeeModule.contract' | translate }}
              </legend>
              <div class="d-flex align-items-center">
                <div class="form-check">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="contractEditable"
                    formControlName="contractEditable"
                  />
                  <label class="form-check-label" for="contractEditable">
                    {{ 'configurationOptionModule.editable' | translate }}
                  </label>
                </div>
              </div>
            </fieldset>
          </div>
        </div>

        <div class="col-lg-6">
          <!-- Description -->
          <div class="mb-4">
            <fieldset>
              <legend class="form-label">
                {{ 'general.description' | translate }}
              </legend>
              <div class="d-flex align-items-center">
                <div class="btn-group-segment">
                  <input
                    type="radio"
                    class="btn-check"
                    name="description"
                    value="{{ true }}"
                    (click)="patchValueForm('descriptionVisible', true)"
                    id="descriptionBookingbtnradio1"
                    autocomplete="off"
                    [checked]="form.value.descriptionVisible"
                  />
                  <label class="btn" for="descriptionBookingbtnradio1">
                    {{ 'general.yes' | translate }}
                  </label>

                  <input
                    type="radio"
                    class="btn-check"
                    name="description"
                    id="descriptionBookingbtnradio2"
                    value="{{ false }}"
                    (click)="patchValueForm('descriptionVisible', false)"
                    autocomplete="off"
                    [checked]="!form.value.descriptionVisible"
                  />
                  <label class="btn" for="descriptionBookingbtnradio2">
                    {{ 'general.no' | translate }}
                  </label>
                </div>
                <div class="form-check ms-3">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="descriptionIsRequiredBooking"
                    formControlName="descriptionRequired"
                  />
                  <label for="descriptionIsRequiredBooking">{{
                    'configurationOptionModule.required' | translate
                  }}</label>
                </div>
                <div class="form-check ms-3">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="descriptionIsEditableBooking"
                    formControlName="descriptionEditable"
                  />
                  <label for="descriptionIsEditableBooking">{{
                    'configurationOptionModule.editable' | translate
                  }}</label>
                </div>
              </div>
            </fieldset>
          </div>

          <!-- Additional Info -->
          <div class="mb-4">
            <fieldset>
              <legend class="form-label">
                {{ 'general.additionalInfo' | translate }}
              </legend>
              <div class="d-flex align-items-center">
                <div class="btn-group-segment">
                  <input
                    type="radio"
                    class="btn-check"
                    name="additionalInfo"
                    value="{{ true }}"
                    (click)="patchValueForm('additionalInfoVisible', true)"
                    id="additionalInfoBookingbtnradio1"
                    autocomplete="off"
                    [checked]="form.value.additionalInfoVisible"
                  />
                  <label class="btn" for="additionalInfoBookingbtnradio1">
                    {{ 'general.yes' | translate }}
                  </label>

                  <input
                    type="radio"
                    class="btn-check"
                    name="additionalInfo"
                    id="additionalInfoBookingbtnradio2"
                    value="{{ false }}"
                    (click)="patchValueForm('additionalInfoVisible', false)"
                    autocomplete="off"
                    [checked]="!form.value.additionalInfoVisible"
                  />
                  <label class="btn" for="additionalInfoBookingbtnradio2">
                    {{ 'general.no' | translate }}
                  </label>
                </div>
                <div class="form-check ms-3">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="additionalInfoIsRequiredBooking"
                    formControlName="additionalInfoRequired"
                  />
                  <label for="additionalInfoIsRequiredBooking">{{
                    'configurationOptionModule.required' | translate
                  }}</label>
                </div>
                <div class="form-check ms-3">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="additionalInfoIsEditableBooking"
                    formControlName="additionalInfoEditable"
                  />
                  <label for="additionalInfoIsEditableBooking">{{
                    'configurationOptionModule.editable' | translate
                  }}</label>
                </div>
              </div>
            </fieldset>
          </div>

          <!-- Cancel Booking -->
          <div class="mb-4">
            <fieldset>
              <legend class="form-label">
                {{ 'employeeModule.cancelBooking' | translate }}
              </legend>
              <div class="d-flex">
                <div class="btn-group-segment">
                  <input
                    type="radio"
                    class="btn-check"
                    name="cancelBooking"
                    value="{{ true }}"
                    (click)="patchValueForm('cancelBookingActive', true)"
                    id="cancelBookingbtnradio1"
                    autocomplete="off"
                    [checked]="form.value.cancelBookingActive"
                  />
                  <label class="btn" for="cancelBookingbtnradio1">
                    {{ 'general.yes' | translate }}
                  </label>

                  <input
                    type="radio"
                    class="btn-check"
                    name="cancelBooking"
                    id="cancelBookingbtnradio2"
                    value="{{ false }}"
                    (click)="patchValueForm('cancelBookingActive', false)"
                    autocomplete="off"
                    [checked]="!form.value.cancelBookingActive"
                  />
                  <label class="btn" for="cancelBookingbtnradio2">
                    {{ 'general.no' | translate }}
                  </label>
                </div>
              </div>
            </fieldset>
          </div>

          <!-- Can change -->
          <div class="mb-4">
            <fieldset>
              <legend class="form-label">
                {{ 'configurationOptionModule.employeeIsAllowedChangeEmpBook' | translate }}
              </legend>
              <div class="d-flex">
                <div class="btn-group-segment">
                  <input
                    type="radio"
                    class="btn-check"
                    name="canChange"
                    value="{{ true }}"
                    (click)="patchValueForm('canChange', true)"
                    id="canChangebtnradio1"
                    autocomplete="off"
                    [checked]="form.value.canChange"
                  />
                  <label class="btn" for="canChangebtnradio1">
                    {{ 'general.yes' | translate }}
                  </label>

                  <input
                    type="radio"
                    class="btn-check"
                    name="canChange"
                    id="canChangebtnradio2"
                    value="{{ false }}"
                    (click)="patchValueForm('canChange', false)"
                    autocomplete="off"
                    [checked]="!form.value.canChange"
                  />
                  <label class="btn" for="canChangebtnradio2">
                    {{ 'general.no' | translate }}
                  </label>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="mb-4">
          <label class="form-label">{{
              'configurationOptionModule.employeeSelectableBookingTypes'
                | translate
            }}</label>
          <ng-select
            *ngIf="bookingTypes"
            [items]="bookingTypes"
            [multiple]="true"
            [closeOnSelect]="false"
            [searchable]="true"
            formControlName="bookingTypes"
            bindLabel="key"
            bindValue="value"
            placeholder="{{ 'general.select' | translate }}"
            [clearSearchOnAdd]="true"
            [clearable]="true"
          >
            <ng-template ng-label-tmp let-item="item" let-clear="clear">
              <button
                type="button"
                class="ng-value-icon right btn p-0"
                (click)="clear(item)"
                attr.aria-label="{{ 'general.remove' | translate }}"
              >×</button
              >
              <span class="ng-value-label">{{
                  'employeeModule.bookingType' + item.value | translate
                }}</span>
            </ng-template>
          </ng-select>
        </div>
      </div>
      <div class="form-footer">
        <button class="btn btn-primary" type="submit">
          {{ 'general.save' | translate }}
        </button>
      </div>
    </div>
  </section>
</form>
